import { Injectable } from "@angular/core";
import { ApiService } from "./Api.service";

@Injectable({
  providedIn: "root",
})
export class LevelService {
  constructor(private apiService: ApiService) {}

  /**
   * Public list of educational levels.
   * GET {api_url}/public/levels
   */
  async getLevels() {
    try {
      const res = await this.apiService.get("public/levels");
      return res;
    } catch (error) {
      return error;
    }
  }

  /**
   * Public profile of a single level.
   * GET {api_url}/public/levels/{id}
   * Returns name, slug, descriptions, schedules, educational_proposal,
   * contact, gallery and testimonials.
   */
  async getLevel(id: number | string) {
    try {
      const res = await this.apiService.get(`public/levels/${id}`);
      return res;
    } catch (error) {
      return error;
    }
  }

  /**
   * Send a public contact inquiry to a level (emailed to its web_email).
   * POST {api_url}/public/levels/{id}/inquiry
   * Body is an arbitrary key/value object; keys are printed literally in the mail.
   * Errors propagate so the caller can show feedback.
   */
  sendInquiry(id: number | string, data: { [key: string]: string }) {
    return this.apiService.post(`public/levels/${id}/inquiry`, data);
  }
}
